// ============================================================================
// publicBaseUrl.ts — ВНЕШНИЙ БАЗОВЫЙ URL базы для публичных ссылок (SSoT).
//
// Один порядок для ВСЕХ ссылок, которые открывает человек вне текущего окна
// (вход по QR, приглашения чата, прохождение теста пациентом):
//   1) `base_url` из настроек АКТИВНОЙ базы (внешний адрес публикации);
//   2) внешний URL платформы (`getExternalBaseUrl`: на desktop — конфиг Go,
//      НЕ wails.localhost; в браузере/PWA — origin клиента).
//
// Возвращает URL без хвостового слэша. Ошибка чтения настроек не скрывается
// как «успех»: она журналируется, после чего используется внешний URL
// платформы — тот же детерминированный порядок, что у QR-входа.
// ============================================================================

import { getSDK } from '@/store/sdkStore';
import { useCenterStore } from '@/store/centerStore';
import { getExternalBaseUrl } from '@/lib/wailsBridge';
import { logSwallowed } from '@/lib/errors';

export async function publicBaseUrl(): Promise<string> {
  const slug = useCenterStore.getState().baseSlug;
  if (slug) {
    try {
      const response = await getSDK().base.getBaseSettings({ slug });
      const settings = JSON.parse(String(response?.settings || '{}'));
      const external = String(settings.base_url || '').trim().replace(/\/+$/, '');
      if (/^https?:\/\//i.test(external)) return external;
    } catch (e) {
      logSwallowed(e, 'publicBaseUrl: base_url настроек базы');
    }
  }
  const external = await getExternalBaseUrl();
  return String(external || '').replace(/\/+$/, '');
}
